module.exports = __webpack_public_path__ + "static/media/16.27b8a176.jpg";